<template>
  <div class="wrapper">
    <h3 class="time">{{ elapsedTime }}</h3>
  </div>
</template>

<script>
export default {
  computed: {
    elapsedTime() {
      return this.$store.state.gamemode.elapsedTime;
    },
  },

  beforeDestroy() {
    this.$store.dispatch('stopClock');
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  position: fixed;
  top: 25px;
  right: 25px;
}

.time {
  // Sets the width of the digits to the same value
  font-variant-numeric: tabular-nums;
  margin: 0;
}
</style>
